
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/voucherify",
      function () {
        return require("private-next-pages/destinations/voucherify.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/voucherify"])
      });
    }
  